import { axiosInstanceWithCredentials } from "./base";

export function getAdminSessions(params) {
  return axiosInstanceWithCredentials.get("/sessions", {
    params
  });
}
export function getAdministrators(params) {
  return axiosInstanceWithCredentials.get("/administrators", {
    params
  });
}
export function getAdministratorByEmail(params) {
  return axiosInstanceWithCredentials.get(`/administrator`,{
    params
  });
}
export function createAdministrator(data, params) {
  return axiosInstanceWithCredentials.post("/administrator/", data, {
    params
  });
}

export function updateAdministrator(id, data) {
  return axiosInstanceWithCredentials.put(`/administrator/${id}/`, data);
}

export function deleteAdministrator(id) {
  return axiosInstanceWithCredentials.delete(`/administrator/${id}/`);
}
